// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 6V8H22V2L16 2V4H11.3333V11H8V9H2L2 15H8V13H11.3333L11.3333 20H16V22H22V16H16V18H13.3333L13.3333 6H16Z"}}]};

const TreeSquareDotVerticalFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tree-square-dot-vertical-filled',
    ref,
    icon: element,
  },
));

TreeSquareDotVerticalFilledIcon.displayName = 'TreeSquareDotVerticalFilledIcon';

export default TreeSquareDotVerticalFilledIcon;
